var map = {
	"./asain.png": 192,
	"./bakery.png": 193,
	"./cafe.png": 194,
	"./chicken.png": 195,
	"./dairy.png": 196,
	"./fastfood.png": 197,
	"./fish.png": 198,
	"./kebab.png": 199,
	"./pizza.png": 200,
	"./restaurant.png": 201,
	"./sandwich.png": 202,
	"./supermarket.png": 203,
	"./sushi.png": 204
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 118;


//////////////////
// WEBPACK FOOTER
// ./src/images/segments ^\.\/.*$
// module id = 118
// module chunks = 0